export default function validateData(data) {
    if (data?.orderType === 'courier') {
        return (
            !!data.firstName && !!data.date && !!data.deliveryDate && !!data.month && !!data.beginTime && !!data.endTime
        );
    }
    return !!data?.firstName && !!data?.date;
}
